import { html } from 'fxjs/es';

const href = '/kr/help-center/make-group-kr?hg_id=28&hp_id=2197';

export const bizMarketing = () => html`
  <div class="privacy-popup">
    <div class="privacy-popup__body">
      <span class="privacy-popup__description"
        >마플코퍼레이션은 다양한 협업 사례를 콘텐츠로 제작해 더 많은 분들께 영감을 드리고, 더 좋은 서비스를
        만들어가고자 합니다.</span
      >
      <br />
      <br />
      <table class="privacy-popup__table">
        <thead>
          <tr>
            <th>콘텐츠 활용처</th>
            <th>제작 콘텐츠</th>
            <th>사용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>소셜미디어 채널, 제품 포트폴리오, 마플 홈페이지 등</td>
            <td>제품 완성 사진, 제품 제작 과정 사진, 정보성 글</td>
            <td>동의 철회 시 까지</td>
          </tr>
        </tbody>
      </table>
      <p class="privacy-popup__p">
        사례 활용에 동의 하지 않아도 주문 가능하며, 동의는 언제든 철회할 수 있습니다.
        <a href="${href}" target="_blank">자세히보기</a>
      </p>
      <div class="option">
        <button class="done">확인</button>
      </div>
    </div>
  </div>
`;
